const dropdownItems = document.querySelectorAll('.dropdown-section .dropdown-list');
dropdownItems.forEach(item => {
    const dropdownItemsBtn = item.querySelector('.dropdown-item_btn');
    const dropdownItemsText = item.querySelector('.dropdown-info');
    const maxHeight = dropdownItemsText.scrollHeight + 'px';

    dropdownItemsBtn.addEventListener('click', () => {
        if (item.classList.contains('active')) {
            item.classList.remove('active');
            dropdownItemsText.style.maxHeight = '0';
        } else {
            
            item.classList.add('active');
            dropdownItemsText.style.maxHeight = maxHeight;
        }
    });
});

const optionMenu = document.querySelectorAll('.ap-item__qty');
optionMenu.forEach((item) => {
  const selectBtn = item.querySelector('.select-btn');
  const options = Array.from(item.querySelectorAll('.option'));
  const optionTexts = item.querySelectorAll('.option .option-text');
  const sBtnText = item.querySelector('.sBtn-text');
  const variantSelect = item.closest('.additional-products__item')?.querySelector('.ap-item__variant');
  let focusedIndex = -1;

  const setExpanded = (expanded) => {
    if (!selectBtn) return;
    selectBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    if (!expanded) {
      focusedIndex = -1;
    }
  };

  const markSelected = (idx) => {
    options.forEach((li, i) => {
      if (i === idx) li.setAttribute('aria-selected', 'true');
      else li.setAttribute('aria-selected', 'false');
    });
  };

  const chooseIndex = (idx, labelHTML) => {
    if (typeof idx !== 'number' || idx < 0) return;
    if (labelHTML) sBtnText.innerHTML = labelHTML;
    markSelected(idx);
    if (variantSelect && variantSelect.tagName === 'SELECT') {
      if (variantSelect.options && variantSelect.options.length > idx) {
        variantSelect.selectedIndex = idx;
        const evt = new Event('change', { bubbles: true });
        variantSelect.dispatchEvent(evt);
      }
    }
    item.classList.remove('active');
    setExpanded(false);
    selectBtn?.focus();
  };

  try {
    if (variantSelect && variantSelect.tagName === 'SELECT') {
      const idx = variantSelect.selectedIndex >= 0 ? variantSelect.selectedIndex : 0;
      const optLi = item.querySelector(`.option[data-option-index="${idx}"] .option-text`);
      if (optLi) sBtnText.innerHTML = optLi.innerHTML;
      markSelected(idx);
    } else if (optionTexts[0]) {
      sBtnText.innerHTML = optionTexts[0].innerHTML;
      markSelected(0);
    }
  } catch (e) {}
  setExpanded(false);

  const openMenu = () => {
    item.classList.add('active');
    setExpanded(true);
  };
  const closeMenu = () => {
   setExpanded(false);
    item.style.overflow = 'hidden';
    item.classList.remove('active');
   
  };

  selectBtn?.addEventListener('click', () => {
    const isOpen = item.classList.contains('active');
    if (isOpen) closeMenu(); else openMenu();
  });
  selectBtn?.addEventListener('keydown', (e) => {
    const key = e.key;
    if (key === 'Enter' || key === ' ') {
      e.preventDefault();
      const isOpen = item.classList.contains('active');
      if (isOpen) closeMenu(); else openMenu();
    } else if (key === 'ArrowDown') {
      e.preventDefault();
      openMenu();
      focusedIndex = 0;
      options[0]?.focus();
    } else if (key === 'Escape') {
      closeMenu();
    }
  });

  optionTexts.forEach((optTextEl) => {
    optTextEl.addEventListener('click', (e) => {
      const li = e.currentTarget.closest('.option');
      const indexStr = li?.getAttribute('data-option-index');
      const idx = parseInt(indexStr || '0', 10) || 0;
      chooseIndex(idx, optTextEl.innerHTML);
    });
  });

  options.forEach((li, i) => {
    li.addEventListener('keydown', (e) => {
      const key = e.key;
      if (key === 'Enter' || key === ' ') {
        e.preventDefault();
        chooseIndex(i, li.querySelector('.option-text')?.innerHTML);
      } else if (key === 'ArrowDown') {
        e.preventDefault();
        focusedIndex = Math.min(i + 1, options.length - 1);
        options[focusedIndex]?.focus();
      } else if (key === 'ArrowUp') {
        e.preventDefault();
        focusedIndex = Math.max(i - 1, 0);
        options[focusedIndex]?.focus();
      } else if (key === 'Home') {
        e.preventDefault();
        focusedIndex = 0;
        options[0]?.focus();
      } else if (key === 'End') {
        e.preventDefault();
        focusedIndex = options.length - 1;
        options[focusedIndex]?.focus();
      } else if (key === 'Escape') {
        e.preventDefault();
        closeMenu();
        selectBtn?.focus();
      }
    });
  });

  document.addEventListener('click', (e) => {
    if (!item.contains(e.target)) {
      closeMenu();
    }
  });
});